module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/module.js
// module id = ../../../node_modules/webpack/buildin/module.js
// module chunks = pages.groups.milestones.edit mermaid pages.projects.blame.show pages.projects.blob.edit pages.projects.blob.new pages.projects.blob.show pages.projects.commit.show pages.projects.issues.edit pages.projects.issues.new pages.projects.issues.show pages.projects.merge_requests.creations pages.projects.merge_requests.creations.new pages.projects.merge_requests.edit pages.projects.merge_requests.show pages.projects.milestones.edit pages.groups.milestones.new pages.projects.releases.edit pages.projects.show pages.projects.snippets.edit pages.projects.snippets.new pages.projects.snippets.show pages.projects.tags.new pages.projects.tree.show pages.projects.wikis pages.snippets.edit pages.snippets.new pages.snippets.show pages.groups.epics.show balsamiq_viewer notebook_viewer pages.projects.milestones.new